module.exports = __webpack_public_path__ + "img/works2.d364c17c.png";